import React from "react";
import style from "./SidePanel.scss";
import classNames from 'classnames';

import fonts from "../../../../css/components/fonts.scss";

export default ({player, parentProps, smallView = false}) => {
	const substituteKeeper = parentProps.players.some(player => player.isSubstituteGoalkeeper);
	const keeper = parentProps.players.some(player => player.isGoalkeeper);
    const homeTeam = parentProps.side?.side === 'home';
    let order = 0;
    let marginBottom = 0;
    switch (true) {
        case player.isGoalkeeper:
            order = -2;
            break;
        case player.isSubstituteGoalkeeper:
            order = -1;
            break;
        default:
            order = 0;
            marginBottom = 0;
    }
    const dynamicStyles = {
        order: order,
        marginBottom: marginBottom,
        gridColumn:
            player.isGoalkeeper && !substituteKeeper ||
            player.isSubstituteGoalkeeper && !keeper ? 'span 2' : 'span 1'
    }
    const btnClass = classNames(style.playerBtn, {
        [style.homeTeamStyle]: homeTeam,
        [style.substituteGoalkeeperStyle]: player.isSubstituteGoalkeeper,
        [style.smallView]: smallView,
    })
    
    return (
        <button
            className={`${classNames(style.playerBtn, {
                [style.homeTeamStyle]: homeTeam,
                [style.substituteGoalkeeperStyle]: player.isSubstituteGoalkeeper,
                [style.smallView]: smallView,
            })} ${fonts.fs16}`}
            style={dynamicStyles}
        >
              <span>
                  {player.playerNumber}
              </span>
            {!smallView && (
                <span
                    className={style.playerInitials}
                >{player.lastName}, {player.firstName}</span>
            )}
            {player.isCaptain ? <span className={classNames(style.positionLabel, {[style.smallViewPosition]: smallView, [style.captainSmallView]: smallView})}>C</span> : null}
            {player.isSubstituteGoalkeeper ? <span className={classNames(style.positionLabel, {[style.smallViewPosition]: smallView, [style.subGoalKeeperSmallView]: smallView})}>E</span> : null}
            {player.isGoalkeeper ? <span className={classNames(style.positionLabel, {[style.smallViewPosition]: smallView, [style.goalKeeperSmallView]: smallView})}>T</span> : null}
        </button>
    );
}
